<div class="vault-page-shell">
    <div class="vault-page-header">
      <div class="space-y-3">
        <p class="vault-page-kicker">Access control</p>
        <div class="space-y-2">
        <h1 class="vault-page-title">Connected Apps</h1>
        <p class="vault-page-copy max-w-2xl">Review the apps that currently have permission to access your vault data and verify that each connection still belongs here.</p>
        </div>
      </div>
    </div>
    <div class="vault-divider"></div>

  <section class="vault-panel p-3 sm:p-4">
    <div class="divide-y divide-slate-100">
      <div class="vault-list-row">
        <div class="flex items-center gap-4">
          <div class="vault-icon-tile bg-indigo-50 text-indigo-600">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 14.66V20a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h5.34"/>
              <polygon points="18 2 22 6 12 16 8 16 8 12 18 2"/>
            </svg>
          </div>
          <div class="space-y-1">
            <p class="font-semibold text-slate-900">Acme Labs</p>
            <p class="text-sm text-slate-500">Clinical data import and ongoing sync access.</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <span class="vault-status-pill is-active">Active</span>
          <button class="text-slate-400 transition-colors hover:text-slate-700" type="button" aria-label="View Acme Labs details">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="vault-list-row">
        <div class="flex items-center gap-4">
          <div class="vault-icon-tile bg-emerald-50 text-emerald-600">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
              <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
            </svg>
          </div>
          <div class="space-y-1">
            <p class="font-semibold text-slate-900">Example PHR</p>
            <p class="text-sm text-slate-500">Personal health record access for summaries and timelines.</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <span class="vault-status-pill is-active">Active</span>
          <button class="text-slate-400 transition-colors hover:text-slate-700" type="button" aria-label="View Example PHR details">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="vault-list-row">
        <div class="flex items-center gap-4">
          <div class="vault-icon-tile bg-sky-50 text-sky-600">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/>
              <polyline points="22 4 12 14.01 9 11.01"/>
            </svg>
          </div>
          <div class="space-y-1">
            <p class="font-semibold text-slate-900">Clear Claims</p>
            <p class="text-sm text-slate-500">Insurance claims visibility and shared eligibility checks.</p>
          </div>
        </div>
        <div class="flex items-center gap-3">
          <span class="vault-status-pill is-active">Active</span>
          <button class="text-slate-400 transition-colors hover:text-slate-700" type="button" aria-label="View Clear Claims details">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 18l6-6-6-6"/>
            </svg>
          </button>
        </div>
      </div>

      <div class="vault-list-row cursor-pointer" role="button" tabindex="0">
        <div class="flex items-center gap-4">
          <div class="vault-icon-tile bg-slate-100 text-slate-500">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 5v14M5 12h14"/>
            </svg>
          </div>
          <div class="space-y-1">
            <p class="font-semibold text-slate-900">Add an app</p>
            <p class="text-sm text-slate-500">Connect another trusted app when you’re ready.</p>
          </div>
        </div>
        <span class="text-sm font-semibold text-[#5B47FB]">Browse</span>
      </div>
    </div>
  </section>
</div>
